import { render, staticRenderFns } from "./InternalStats.vue?vue&type=template&id=55811bd2&scoped=true&"
import script from "./InternalStats.vue?vue&type=script&lang=js&"
export * from "./InternalStats.vue?vue&type=script&lang=js&"
import style0 from "./InternalStats.vue?vue&type=style&index=0&id=55811bd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55811bd2",
  null
  
)

export default component.exports